import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { paragraph } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  ${baseGrid};
  width: 100%;

  @media ${from(Device.TabletLarge)} {
    align-items: center;
  }
`;
const ContentArea = styled.div `
  grid-column: span 12;
  width: 100%;
  max-width: 880px;
  margin: auto;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / span 10;
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / span 8;
  }
`;
const IntroContent = styled.div `
  width: 100%;
`;
const Content = styled.div `
  ${paragraph};
  margin-bottom: ${fluid(20, 20)};
`;
const MapWrapper = styled.div `
  position: relative;
  height: 0;
  padding-bottom: ${fluid(378, 500)};
`;
const GoogleMapWidgetStyles = {
    Container,
    Inner,
    IntroContent,
    Content,
    ContentArea,
    MapWrapper,
};
export default GoogleMapWidgetStyles;
